









































































































































































































































































































































































































































  import Component from "vue-class-component";
  import { getModule } from "vuex-module-decorators";
  import { Watch } from "vue-property-decorator";
  import Debounce from "lodash/debounce";
  const { v4: uuidv4 } = require("uuid");
  import Masonry from "masonry-layout";

  import BaseComponent from "@/components/base-component.vue";
  import SearchTitleVideo from "@/components/search-title-video/search-title-video.vue";
  import PackageOffers from "@/components/package-offers/package-offers.vue";
  import ResultsItemVideo from "@/components/results-item-video/results-item-video.vue";
  import VideoPreview from "@/components/video-preview/video-preview.vue";
  import SearchRunner from "@/components/home/search-runner.vue";
  import CapturePhoto from "@/components/capture-photo/capture-photo.vue";
  import Loader from "@/components/loader.vue";
  import NavTabs from "@/components/nav-tabs/nav-tabs.vue";
  import SearchNotFound from "@/components/search-not-found/search-not-found.vue";
  import TwoFactorSearchNumber from "@/components/two-factor-search-number/two-factor-search-number.vue";
  import TwoFactorSearchSelfie from "@/components/two-factor-search-selfie/two-factor-search-selfie.vue";
  import TwoFactorSearchEmail from "@/components/two-factor-search-email/two-factor-search-email.vue";
  import BaseIcon from "@/components/base-icon/base-icon.vue";
  import BaseIllustration from "@/components/base-illustration/base-illustration.vue";
  import IconCheckCircle from "@/components/icons/icon-check-circle.vue";
  import NoDataRafiki from "@/components/illustrations/no-data-rafiki.vue";
  import NotFoundPhotos from "@/components/illustrations/not-found-photos.vue";
  import { CatalogState } from "@/store/modules/catalog";
  import { CartState } from "@/store/modules/cart";
  import { SearchState } from "@/store/modules/search";
  import { EventsState } from "@/store/modules/events";
  import { InvoicesState } from "@/store/modules/invoices";
  import { CaptureState } from "@/store/modules/capture";
  import { SettingsState } from "@/store/modules/settings";
  import { ProductTypes } from "@/product-types";
  import { OfferTypes } from "@/offer-types";
  import { OfferStates } from "@/offer-states";
  import { SearchTypes } from "@/search-types";
  import Common from "@/plugins/common";

  @Component({
    name: "SearchResults",
    props: {
      eventId_: String,
      eventName_: String,
      eventDate_: String,
      runnerNum_: String,
      runnerFrameValues_: String,
      byFace_: String,
      faceImage_: String,
      selfieId_: String,
      personId_: String,
      videos_: String,
      notFound_: String,
      backPageData_: Object,
      is2FAEnabled_: Boolean,
      searchType_: String,
      isAllPhotosVisible_: Boolean,
      searchToken_: Object,
    },
    components: {
      SearchTitleVideo,
      PackageOffers,
      ResultsItemVideo,
      VideoPreview,
      SearchRunner,
      CapturePhoto,
      Loader,
      NavTabs,
      SearchNotFound,
      TwoFactorSearchNumber,
      TwoFactorSearchSelfie,
      TwoFactorSearchEmail,
      BaseIcon,
      BaseIllustration,
      IconCheckCircle,
      NoDataRafiki,
      NotFoundPhotos,
    },
  })
  export default class SearchResults extends BaseComponent {

    private readonly catalogState: CatalogState = getModule(CatalogState, this.$store);
    private readonly cartState: CartState = getModule(CartState, this.$store);
    private readonly searchState: SearchState = getModule(SearchState, this.$store);
    private readonly eventsState: EventsState = getModule(EventsState, this.$store);
    private readonly invoicesState: InvoicesState = getModule(InvoicesState, this.$store);
    private readonly captureState: CaptureState = getModule(CaptureState, this.$store);
    private readonly settingsState: SettingsState = getModule(SettingsState, this.$store);

    private debouncedDoSearch: any = null;

    productTypes: any = ProductTypes;
    catalogProducts: any[] = [];
    frameProducts: any[] = [];
    
    itemDropdown: boolean = false;
    itemPhotoPrice: number = 0;

    hoveredItemIndex: number = -1;

    navItems: any[] = [];
    navActiveItemId: string = '';
    navIsVisible: boolean = false;

    eventId: string = "";
    eventName: string = "";
    eventDate: string = "";
    is2FAEnabled: boolean = false;
    isAllPhotosVisible: boolean = false;
    runnerNum: string = "";
    runnerLastName: string = "";
    runnerFrameValues: any = null;
    byFace: boolean = false;

    searchToken: any = null;
    allPhotosTokenValue: string = "";

    tagged: boolean = false;

    faceImage: string = "";
    selfieId: string = "";
    personId: string = "";
    
    notFound__: string = "";

    videos: any[] = [];
    videosAddingToCart: any[] = [];
    videosInCart: string[] = [];

    photoLoaderBlock: any = null;
    updating: boolean = false;
    startFrom: number = 0;
    
    packageOffers: any[] = [];
    showPackageOffers: boolean = false;
    packageOffersOptions: any[] = [];

    resultsType: number = 1;

    videoPreviewDialog: boolean = false;
    videoPreviewDialogKey: string = "";
    previewVideos: any[] = [];
    currentVideoIndex: number = 0;

    selectedFrameValues: any = null;

    runnersContainerId: string = "";
    runnersDialog: boolean = false;
    runnersDialogKey: string = "";
    runnersHeight: string = "auto";
    
    captureDialog: boolean = false;
    input: any = null;
    selectedFile: File | null = null;
    redrawImage: boolean = false;
    searchResult: string = "";

    loading: boolean = true;
    isAddingVideos: boolean = false;

    showSbp: boolean = false;

    resultsMasonryGrid: any = null;

    get isMobile(): boolean {
      const r: any = this.$root;
      return r.isMobile;
    }

    get isTablet(): boolean {
      const r: any = this.$root;
      return r.isTablet;
    }

    get theme(): any {
      return this.settingsState.theme;
    }

    get tenantName(): any {
      return this.settingsState.tenantName;
    }

    get features(): any {
      return this.settingsState.features;
    }

    get sbpEnabled(): boolean {
      return this.features ? this.features.includes('sbp') : false;
    }

    get rounding(): any {
      return this.settingsState.rounding;
    }

    get roundMainAmount(): boolean {
      return this.rounding ? this.rounding.searchResultsMain === true : false;
    }

    get roundTotalAmount(): boolean {
      return this.rounding ? this.rounding.searchResultsTotal === true : false;
    }

    get roundOtherAmounts(): boolean {
      return this.rounding ? this.rounding.searchResultsOther === true : false;
    }

    get cart(): any {
      return this.cartState.cart;
    }

    get cartItemsCount(): number {
      return this.cartState.itemsCount;
    }

    get cartTotalAmount(): number {
      return this.cartState.totalAmount;
    }

    get isSearchingByStartNumber(): boolean {
      return this.$props.searchType_ === SearchTypes.startNumber;
    }

    get isSearchingByEmail(): boolean {
      return this.$props.searchType_ === SearchTypes.email;
    }

    get isFaceSearchEnabled(): boolean {
      return this.eventsState.event ? this.eventsState.event?.searchingPhotos?.byFace === true : false;
    }

    get isTagSearchEnabled(): boolean {
      return this.eventsState.event ? this.eventsState.event?.searchingPhotos?.byTag === true : false;
    }

    get notFound(): boolean {
      return this.notFound__ === "true";
    }

    get photosWithMeProduct(): any {
      const products: any[] = this.getCatalogProducts(this.productTypes.photos_with_me);
      if (products.length == 0) return null;
      return products[0];
    }

    get photosWithFrameProduct(): any {
      const products: any[] = this.getCatalogProducts(this.productTypes.photosWithFrame);
      if (products.length == 0) return null;
      return products[0];
    }

    get photoProduct(): any {
      const products: any[] = this.getCatalogProducts(this.productTypes.photo);
      if (products.length == 0) return null;
      return products[0];
    }

    get promocodeProduct(): any {
      const products: any[] = this.getCatalogProducts(this.productTypes.promocode);
      if (products.length == 0) return null;
      return products[0];
    }

    get videoProduct(): any {
      const products: any[] = this.getCatalogProducts(this.productTypes.video);
      if (products.length == 0) return null;
      return products[0];
    }

    get videosTotalAmount(): number {
      let amount = 0;
      if (this.videoProduct && this.videos.find((i: any) => i.type === this.productTypes.video)) amount += this.videoProduct.amount;
      return parseFloat((amount).toFixed(2));
    }

    get photosWithMeDiscount(): number {
      if (!this.photosWithMeProduct) {
        return 0;
      }
      const discount = (this.itemPhotoPrice * this.searchState.photosTotal) - this.photosWithMeProduct.amount;
      // MSP:
      // return parseFloat((discount).toFixed(0));
      return parseFloat((discount).toFixed(2));
    }

    get photosWithFrameDiscount(): number {
      if (!this.photosWithFrameProduct) {
        return 0;
      }
      const frameId = Common.getAttribute(this.photosWithFrameProduct.attributes, 'FrameId');
      const amount = this.getSingleFrameAmount(frameId);
      if (!amount) return 0;
      const discount = (amount * this.searchState.photosTotal) - this.photosWithFrameProduct.amount;
      // MSP:
      // return parseFloat((discount).toFixed(0));
      return parseFloat((discount).toFixed(2));
    }

    get hasPackageOffers(): boolean {
      return this.packageOffers.length > 0;
    }

    get hasEventProductsInCart(): boolean {
      return this.isEventProductsInCart();
    }

    get areAllVideosInCart(): boolean {
      const video = this.videoProduct ? this.isProductInCart(this.productTypes.video) : true;
      return video;
    }

    get lang(): string {
      return this.settingsState.lang;
    }

    get currencyAlertClosed(): boolean {
      return localStorage.getItem('currencyAlertClosed') === 'true';
    }

    set currencyAlertClosed(val) {
      localStorage.setItem('currencyAlertClosed', val.toString());
    }

    get isEmail(): boolean {
      return this.$route.name === 'search-verify-email';
    }

    isStartNumber(id: string): boolean {
      if (!id) return false;
      if (!this.isEmail && id.indexOf("+") < 0) return true;
      return false;
    }

    get bannerSliderItems(): any[] {
      return [];
    }

    get paymentDiscountItems(): any[] {
      const items = [
        { img: '/img/sbp/short-sbp.svg', text: this.$t('paymentDiscount/sbp'.toString()) },
      ];

      return this.showSbp ? items : [];
    }

    get photosPerPage(): number {
      if (this.smOnly || this.mdOnly) return 12;
      return 50;
    }

    async updateSbpState(): Promise<void> {
      if (this.sbpEnabled !== true) return;

      await this.invoicesState.getPaymentTypes({ 
        amount: this.photoProduct.amount, 
        currencyId: this.photoProduct.currencyId,
        albumId: await this.getAlbumIds(),
      });

      const types: any[] = this.invoicesState.paymentTypes;
      const index = types.findIndex((r: any) => r.paymentTypeId === 'QuickPayment');
      if (this.theme === '' && this.tenantName !== 'Sporttiming' && index >= 0) {
        this.showSbp = true;
        return;
      }

      this.showSbp = false;
    }

    async getAlbumIds(): Promise<string[]> {
      const albumId: string[] = [];
      
      if (!this.cartState.cart || this.cartState.cartItems.length === 0) {
        return [this.eventId];
      }
      
      const items: any[] = this.cartState.cartItems;
      for (let i = 0; i < items.length; i += 1) {
        const id: string = items[i].catalog?.catalogId || "";
        if (id && !albumId.includes(id)) albumId.push(id);
      }
      if (!albumId.includes(this.eventId)) albumId.push(this.eventId);
      
      return albumId;
    }

    setPictureHandlers(): void {
      const input: any = document.getElementById("cameraInput");
      if (!input) return;
      this.input = input;
      input.onchange = this.onPictureChange;
    }

    formatAmount(amount: number, onlyInteger: boolean = this.roundOtherAmounts): string {
      return Common.formatAmount(amount, onlyInteger);
    }

    getItemClass(videoId: string): string {
      let result: string = "";
      if (this.smOnly) {
        result = "list__item " + (!this.videosInCart.includes(videoId) ? "item--unchecked" : "");
      } else {
        result = "list__item item--large " + (!this.videosInCart.includes(videoId) ? "item--unchecked" : "");
      }
      return result;
    }

    showPackageOffer(productId: string): void {      
      const offers = this.getPackageOffers(productId);

      const routes = ['search-from-url-video'];

      const root: any = this.$root;
      for (let i = 0; i < offers.length; i += 1) {
        setTimeout(() => {
          const routeName = this.$route.name || '';
          if (!routes.includes(routeName)) return;
          root.$addNotification(offers[i]);
        }, 1000);
      }
    }

    showGiftForProduct(product: any): void {
      if (!product) return;
      const gift = this.getGiftForProduct(product);
      if (gift) {
        const productInCart = this.getCartItemsWithProductId(product.productId).length;
        const giftInCart = this.getCartItemsWithProductId(gift.product.productId).length;
        if (productInCart === gift.quantity && giftInCart === 0) {
          const props = this.getGiftProps({ ...gift, trigger: { ...product } });
          const root: any = this.$root;
          if (props) {
            const routes = ['search-from-url-video'];
            setTimeout(() => {
              const routeName = this.$route.name || '';
              if (!routes.includes(routeName)) return;
              root.$addNotification(props);
            }, 1000);
          }
        }
      }
    }

    getPackageOffers(productId: string): Array<any> {
      if (this.videoProduct && productId === this.videoProduct.productId) {
        return this.getPackageOffersForVideo();
      }

      return [];
    }

    getPackageOffersForVideo(): Array<any> {
      if (!this.videoProduct) return [];

      const videoInCart: any[] = this.getCartItemsWithProductId(this.videoProduct.productId);
      if (videoInCart.length === 0) return [];

      const offers: any[] = [];

      const candidate: any = this.getDiscountCandidateForProduct(this.videoProduct);
      if (candidate) {
        if (videoInCart.length > candidate.quantity) return [];
        const candidateInCart: any[] = this.getCartItemsWithProductId(candidate.product.productId);
        if (candidateInCart.length > 0) return [];
        const props = this.getDiscountForVideoProps({ ...candidate, trigger: { ...this.videoProduct } });
        if (props) {
          if (props) offers.push(props);
        }
      }

      return offers;
    }

    getDiscountForVideoProps(data: any): any {
      const currentPrice = this.formatAmount(data.product.amount);
      const newPrice = this.formatAmount(data.price);
      let title = data.product.productType === this.productTypes.frame ? this.$t('searchResults/productPhotoFrame').toString() : data.product.title;
      const props: any = {
        title: this.$t('packageOffers/received'),
        text: this.$t('packageOffers/getProduct', [title, newPrice, currentPrice]).toString(),
        img: '/img/package.svg',
        discountText: '',
        declineText: this.$t('packageOffers/notInteresting').toString(),
        confirmText: this.$t('packageOffers/get').toString(),
        confirmType: 'primary',
        confirmIcon: '',
      };
      const handlers: any = {
        confirm: () => {
          // На страницу с найденными фотографиями
          this.onShowMyPhotos();
        },
        decline: () => {
          // Скрыть уведомление насовсем
        },
        dismiss: () => {
          // Скрыть уведомление на 7 суток
        },        
      };
      return { props, ...handlers };
    }

    getGiftProps(gift: any): any {
      if (!gift) return null;

      const giftTitle = gift.product.productType === this.productTypes.frame ? this.$t('searchResults/productPhotoFrame').toString() : gift.product.title;
      const triggerTitle = gift.trigger.productType === this.productTypes.frame ? this.$t('searchResults/productPhotoFrame').toString() : gift.trigger.title;
      const props: any = {
        title: this.$t('packageOffers/getGift').toString(),
        text: this.$t('packageOffers/productPer', [giftTitle, gift.size, triggerTitle, gift.quantity]).toString(),
        img: this.getProductImage(gift.product),
        discountText: '',
        declineText: this.$t('packageOffers/notInteresting').toString(),
        confirmText: this.$t('packageOffers/get').toString(),
        confirmType: 'primary',
        confirmIcon: 'gift',
      };
      const handlers: any = {
        confirm: () => {
          // На страницу с подробностями
          this.onShowOffers();
        },
        decline: () => {
          // Скрыть уведомление насовсем
        },
        dismiss: () => {
          // Скрыть уведомление на 7 суток
        },        
      };
      return { props, ...handlers };
    }

    getProductImage(product: any): string {
      if (!product) return '';
      if (product.productType === this.productTypes.photos_with_me) return '/img/all-photos.svg';
      if (product.productType === this.productTypes.photosWithFrame) return '/img/all-photos-in-frame.svg';
      if (product.productType === this.productTypes.photo) return '/img/single-photo.svg';
      if (product.productType === this.productTypes.frame) return '/img/photo-in-frame.svg';
      if (product.productType === this.productTypes.promocode) return '/img/promocode.svg';
      return '';
    }

    getProductTitle(product: any): string {
      const type = product.productType;
      if (!type) return '';

      if (type === this.productTypes.photos_with_me) {
        return this.$t('productPreview/productAllPhotos').toString();
      } else if (type === this.productTypes.photosWithFrame) {
        return product.title;
      } else if (type === this.productTypes.photo) {
        return this.$t('productPreview/productDigitalPhoto').toString();
      } else if (type === this.productTypes.video) {
        return product.title;
      } else if (type === this.productTypes.promocode) {
        return product.title;
      } else {
        return this.$t('searchResults/productPhotoFrame').toString();
      }
    }

    getProductDescription(offer: any): string {
      if (!offer) return '';
      if (offer.productType === this.productTypes.photos_with_me) return this.$t('packageOffers/photosWithMe').toString();
      if (offer.productType === this.productTypes.photosWithFrame) return this.$t('packageOffers/photosWithFrame').toString();
      if (offer.productType === this.productTypes.photo) return this.$t('packageOffers/anyPhotos', [offer.size]).toString();
      if (offer.productType === this.productTypes.video) return '';
      if (offer.productType === this.productTypes.frame) return '';
      if (offer.productType === this.productTypes.promocode) return '';
      return '';
    }

    getPackageOffersOptions() {
      const options = [];
      
      const products = this.getOfferProducts();
      if (products) options.push(products);
      
      const packages = this.getOfferPackages();
      if (packages) options.push(packages);
      
      const gifts = this.getOfferGifts();
      if (gifts) options.push(gifts);

      return options;
    }

    getOfferProducts(): any {
      const result = {
        title: 'packageOffers/products',
        type: OfferTypes.product,
      };

      const items: any[] = [];
      const isAllPhotos = this.$route.name === 'event-photos';

      if (this.photosWithMeDiscount > 0) {
        const inCart = this.isProductIdInCart(this.photosWithMeProduct.productId);
        items.push({
          type: OfferTypes.product,
          state: inCart ? OfferStates.inCart : OfferStates.initial,
          title: this.photosWithMeProduct.title,
          subtitle: this.$t('packageOffers/photosWithMe').toString(),
          price: this.formatAmount(this.photosWithMeProduct.amount),
          image: this.getProductImage(this.photosWithMeProduct),
          action: inCart ? 
            { icon: 'check-bold', text: this.$t('packageOffers/inCart').toString() } :
            { icon: 'shopping-cart', text: this.$t('packageOffers/add').toString(), func: () => this.onAddPhotosWithMe() },
          isAllPhotos,
        });
      }

      if (this.photosWithFrameDiscount > 0) {
        const inCart = this.isProductIdInCart(this.photosWithFrameProduct.productId);
        items.push({
          type: OfferTypes.product,
          state: inCart ? OfferStates.inCart : OfferStates.initial,
            title: this.photosWithFrameProduct.title,
            subtitle: this.$t('packageOffers/photosWithFrame').toString(),
            price: this.formatAmount(this.photosWithFrameProduct.amount),
            image: this.getProductImage(this.photosWithFrameProduct),
            action: inCart ? 
              { icon: 'check-bold', text: this.$t('packageOffers/inCart').toString() } : 
              { icon: 'shopping-cart', text: this.$t('packageOffers/add').toString(), func: () => this.onPhotosWithFrameAdd() },
            isAllPhotos,
        });
      }

      return items.length > 0 ? { ...result, items } : null;
    }

    getOfferPackages(): any {
      const result = {
        title: 'packageOffers/packages',
        type: OfferTypes.package,
      };

      const items: any[] = [];

      for (let i = 0; i < this.packageOffers.length; i += 1) {
        const offer = this.packageOffers[i];
        if (offer.dependencies ? offer.dependencies.length > 0 : false) continue;
        if (offer.productType === this.productTypes.photos_with_me) continue;
        if (offer.size === 1) continue;
        if (offer.price === 0) continue;
        const productCount = this.getCartItemsWithProductId(offer.productId);
        const title = offer.productType === this.productTypes.frame ? this.$t('searchResults/productPhotoFrame').toString() : offer.title;
        items.push({
          type: OfferTypes.package,
          state: OfferStates.initial,
          title: this.$t('packageOffers/productQty', [title, offer.size]).toString(),
          subtitle: this.getProductDescription(offer),
          price: this.formatAmount(offer.price),
          oldPrice: offer.oldPrice ? this.formatAmount(offer.oldPrice) : 0,
          image: offer.productType !== this.productTypes.video ? '/img/package.svg' : '/img/video-package.svg',
          progress: { value: productCount.length, max: offer.size, },
        });
      }

      for (let k = 0; k < this.catalogProducts.length; k += 1) {
        const item = this.getSalePackage(this.catalogProducts[k]);
        if (item) items.push(item);
      }

      for (let i = 0; i < this.packageOffers.length; i += 1) {
        const offer = this.packageOffers[i];
        if (offer.dependencies ? offer.dependencies.length === 0 : true) continue;
        if (offer.price === 0) continue;
        const productCount = this.getCartItemsWithProductId(offer.productId);
        const dependencyProducts = this.catalogProducts.filter((item: any) => item.productId === offer.dependencies[0].productId);
        if (dependencyProducts.length === 0) continue;
        const quantity = offer.dependencies[0].quantity;
        const dependencyTitle = dependencyProducts[0].productType === this.productTypes.frame ? this.$t('searchResults/productPhotoFrame').toString() : dependencyProducts[0].title;
        const dependency = `<b>${dependencyTitle}${quantity > 0 ? ' x ' + quantity + '&nbsp;' + this.$t('saleSnackbar/qty') : ''}</b>`;
        const offerTitle = offer.productType === this.productTypes.frame ? this.$t('searchResults/productPhotoFrame').toString() : offer.title;
        items.push({
          type: OfferTypes.package,
          state: OfferStates.initial,
          title: this.$t('packageOffers/productQty', [offerTitle, offer.size]).toString(),
          subtitle: this.getProductDescription(offer),
          price: this.formatAmount(offer.price),
          oldPrice: offer.oldPrice ? this.formatAmount(offer.oldPrice) : 0,
          image: offer.productType !== this.productTypes.video ? '/img/package.svg' : '/img/video-package.svg',
          progress: { value: productCount.length, max: offer.size, },
          warning: dependency,
        });
      }

      return items.length > 0 ? { ...result, items } : null;
    }

    getOfferGifts(): any {
      const result = {
        title: 'packageOffers/gifts',
        type: OfferTypes.gift,
      };

      const items: any[] = [];

      for (let k = 0; k < this.catalogProducts.length; k += 1) {
        const item = this.getGiftForProduct(this.catalogProducts[k]);
        if (item) {
          const gift = this.getGiftItem({ ...item, trigger: { ...this.catalogProducts[k] } });
          if (gift) items.push(gift);
        }
      }

      return items.length > 0 ? { ...result, items } : null;
    }

    getGiftForProduct(product: any): any {
      if (!product) return null;
      const candidates: any[] = [...product.candidates];
      for (let i = 0; i < candidates.length; i += 1) {
        const gifts: any[] = candidates[i].packageOffers.filter((r: any) => r.price === 0);
        if (gifts.length > 0) {
          const quantity = gifts[0].dependencies[0] ? gifts[0].dependencies[0].quantity : 0;
          if (quantity) {
            return { product: { ...candidates[i] }, quantity, size: gifts[0].size };
          }
          return null;
        }
      }
      return null;
    }

    getDiscountCandidateForProduct(product: any): any {
      if (!product) return null;
      const candidates: any[] = [...product.candidates];
      for (let i = 0; i < candidates.length; i += 1) {
        const items: any[] = candidates[i].packageOffers.filter((r: any) => r.price > 0);
        if (items.length > 0) {
          const quantity = items[0].dependencies[0] ? items[0].dependencies[0].quantity : 0;
          if (quantity) {
            return { product: { ...candidates[i] }, quantity, size: items[0].size, price: items[0].price };
          }
          return null;
        }
      }
      return null;
    }

    getSalePackage(product: any): any {
      if (!product) return null;

      const rule = product.priceRule;
      const discount = rule ? rule.discount : null;

      if (!rule || !discount) return null;

      const currentPrice = this.formatAmount(product.amount);
      const discountedPrice = discount.unit === 'Percentage' ? product.amount - (product.amount * (discount.value / 100)) : product.amount - discount.value;
      const newPrice = this.formatAmount(discountedPrice, this.roundTotalAmount);
      const props: any = {
        type: OfferTypes.package,
        state: OfferStates.initial,
        title: `${this.getProductTitle(product)}`,
        subtitle: this.$t('packageOffers/qtyRange', [rule.minQuantity + 1, rule.maxQuantity]).toString(),
        price: newPrice,
        oldPrice: currentPrice,
        image: this.getProductImage(product),
      };
      return props;
    }

    getGiftItem(gift: any): any {
      if (!gift) return null;

      const productCount = this.getCartItemsWithProductId(gift.product.productId).length;
      const triggerCount = this.getCartItemsWithProductId(gift.trigger.productId).length;
      let state = OfferStates.initial;
      if (productCount >= gift.size && triggerCount >= gift.quantity) state = OfferStates.inCart;
      if (productCount < gift.size && triggerCount >= gift.quantity) state = OfferStates.giftReady;
      
      let action = null;
      if (state === OfferStates.giftReady) action = { icon: 'gift', text: this.$t('packageOffers/get').toString(), func: () => this.addGift(gift) };
      if (state === OfferStates.inCart) action = { icon: 'check-bold', text: this.$t('packageOffers/giftInCart').toString() };

      const isAllPhotos = this.$route.name === 'event-photos';

      const giftTitle = gift.product.productType === this.productTypes.frame ? this.$t('searchResults/productPhotoFrame').toString() : gift.product.title;
      const triggerTitle = gift.trigger.productType === this.productTypes.frame ? this.$t('searchResults/productPhotoFrame').toString() : gift.trigger.title;
      const props: any = {
        type: OfferTypes.gift,
        state,
        title: this.$t('packageOffers/productQty', [giftTitle, gift.size]).toString(),
        subtitle: this.$t('packageOffers/giftFor', [triggerTitle, gift.quantity]).toString(),
        image: this.getProductImage(gift.product),
        action,
        isAllPhotos,
      };
      return props;
    }

    sortOffers(a: any, b: any): number {
      if (a.size < b.size) return -1;
      if (a.size > b.size) return 1;
      return 0;
    }

    async isTagged(): Promise<boolean> {
      if (this.eventsState.event === null) return false;
      return this.eventsState.event.searchingPhotos.byTag === true;
    }

    isEventProductsInCart(): boolean {
      if (this.isProductInCart(this.productTypes.photos_with_me) ||
          this.isProductInCart(this.productTypes.photosWithFrame) ||
          this.isProductInCart(this.productTypes.photo) ||
          this.isProductInCart(this.productTypes.frame) ||
          this.isProductInCart(this.productTypes.video)) {
        return true;
      }
      return false;
    }

    getCatalogProducts(type: string): any[] {
      const products: any[] = Object.assign([], this.catalogProducts);
      if (products.length === 0) {
        return [];
      } else {      
        const found: any[] = products.filter((r: any) => r.productType === type);
        if (found.length > 0) {
          for (let i = 0; i < found.length; i++) {
            if (type === this.productTypes.frame) found[i].title = this.$t('searchResults/productPhotoFrame').toString();
          }
        }
        return found;
      }
    }

    isProductEnabled(type: string): boolean {
      if (this.catalogProducts.length === 0) {
        return false;
      } else {      
        return this.catalogProducts.filter((r: any) => r.productType === type).length > 0;
      }
    }

    isProductInCart(type: string): boolean {

      if (type == "") return false;

      if (this.cartState.itemsCount == 0) {
        return false;
      } else {      
        
        const items: any[] = this.cartState.cartItems;
        for (let i of items) {
          if (!i.product) continue;
          if (!i.product.productId) continue;
          if (!i.catalog) continue;
          if (!i.catalog.catalogId) continue;
          if (i.catalog.catalogId != this.eventId) continue;
          
          if (i.additionalAttributes) {
            const additionalAttributes: any[] = i.additionalAttributes;

            const productType: string = i.product.productType;
            if (productType.length == 0) continue;
            if (productType != type) continue;

            const byFace: string = Common.getAttribute(additionalAttributes, "byFace");
            if (byFace.length == 0) continue;
            if (byFace != this.byFace.toString()) continue;

            if (!this.byFace) {
              const runnerNum: string = Common.getAttribute(additionalAttributes, "runnerNum");
              if (runnerNum.length == 0) continue;
              if (runnerNum != this.runnerNum) continue;
            } else {
              const selfieId: string = Common.getAttribute(additionalAttributes, "selfieId");
              if (selfieId.length == 0) continue;
              if (selfieId != this.selfieId) continue;
              
              const personId: string = Common.getAttribute(additionalAttributes, "personId");
              if (personId.length == 0) continue;
              if (personId != this.personId) continue;
            }

            return true;
          } 
        }
        return false;
      }
    }

    isProductIdInCart(productId: string, currentSearchOnly: boolean = false): boolean {
      if (productId === '') return false;

      if (this.cartState.itemsCount === 0) return false;

      const items: any[] = this.cartState.cartItems;
      for (let i of items) {
        if (!i.product) continue;
        if (!i.product.productId) continue;
        if (i.product.productId !== productId) continue;
        if (currentSearchOnly) {
          const additionalAttributes: any[] = i.additionalAttributes;
          const byFace: string = Common.getAttribute(additionalAttributes, 'byFace');
          if (byFace.length === 0) continue;
          if (byFace !== this.byFace.toString()) continue;

          if (!this.byFace) {
            const runnerNum: string = Common.getAttribute(additionalAttributes, 'runnerNum');
            if (runnerNum.length === 0) continue;
            if (runnerNum !== this.runnerNum) continue;
          } else {
            const selfieId: string = Common.getAttribute(additionalAttributes, 'selfieId');
            if (selfieId.length === 0) continue;
            if (selfieId !== this.selfieId) continue;
            
            const personId: string = Common.getAttribute(additionalAttributes, 'personId');
            if (personId.length === 0) continue;
            if (personId !== this.personId) continue;
          }
        }
        return true;
      }

      return false;
    }

    getCartItemsWithProductId(productId: string): any[] {
      let result: any[] = [];

      const items: any[] = [ ...this.cartState.cartItems ];
      if (items.length == 0) {
        return [];
      } 

      for (let i = 0; i < items.length; i++) {
        if (!items[i].product) continue;
        if (items[i].product.productId == productId) {
          result.push(items[i]);
        } 
      }
      return result;
    }

    setSelectedFrameValues(): void {
      this.selectedFrameValues = { };

      const frameValues: any = { ...this.runnerFrameValues };

      if (frameValues) {
        this.selectedFrameValues['competitorId'] = frameValues.competitorId || "";
        this.selectedFrameValues['surname'] = frameValues.surname || "";
        this.selectedFrameValues['firstName'] = frameValues.firstName || "";
        this.selectedFrameValues['time'] = frameValues.time || "";
        this.selectedFrameValues['distance'] = frameValues.distance || "";
      }
    }

    getVideoAttributes(): any[] {
      const attributes: any[] = [];

      attributes.push({ key: "byFace", value: this.byFace.toString() });

      if (!this.byFace) {
        attributes.push({ key: "runnerNum", value: this.runnerNum });
        attributes.push({ key: "StartNumber", value: this.runnerNum });
      } else {
        attributes.push({ key: "selfieId", value: this.selfieId });
        attributes.push({ key: "personId", value: this.personId });
        attributes.push({ key: "PersonId", value: this.personId });
      }

      return attributes;
    }

    getItemVideos(item: any): string[] {
      if (!item) return [];
      
      const type: string = item.product ? item.product.productType : '';

      let videoIds: string[] = [];
      if (type == this.productTypes.video) {
        videoIds = [ item.product.video.videoId ];
      }

      return videoIds;
    }

    isVideoAddingToCart(videoId: string): boolean {
      const item = this.videosAddingToCart.find((i: any) => i.id === videoId);
      if (item) {
        return item.adding === true;
      }
      return false;
    }

    disableVerticalScroll(disable: boolean) {
      if (disable) {
        document.documentElement.setAttribute('style', 'overflow-y: hidden !important;');
        document.body.style.overflowY = 'hidden';
      } else {
        document.documentElement.setAttribute('style', '');
        document.body.style.overflowY = '';
      }
    }

    getSingleFrameAmount(frameId: string): number {
      for (let i = 0; i < this.frameProducts.length; i += 1) {
        const id = Common.getAttribute(this.frameProducts[i].attributes, 'FrameId');
        if (id === frameId) return this.frameProducts[i].amount;
      }
      return 0;
    }

    getFramesInCart(): any[] {
      const result = [];
      for (let i = 0; i < this.frameProducts.length; i += 1) {
        const items = this.getCartItemsWithProductId(this.frameProducts[i].productId);
        result.push(...items);
      }
      if (this.photosWithFrameProduct && this.isProductIdInCart(this.photosWithFrameProduct.productId, true)) {
        const items = this.getCartItemsWithProductId(this.photosWithFrameProduct.productId);
        result.push(...items);
      }
      return result;
    }

    setNavItems() {
      const items: any[] = [];
      const event = { ...this.eventsState.event };
      items.push({ id: 'my-photos', title: this.$t('event/titleMy'), disabled: false, action: this.onShowMyPhotos });
      if (this.hasVideo(event) && this.isTagSearchEnabled) items.push({ id: 'video', title: this.$t('event/titleVideo'), disabled: false, action: this.onShowVideo });
      if (this.hasAllPhotos(event)) items.push({ id: 'all-photos', title: this.$t('event/titleAll'), disabled: false, action: this.onShowAllPhotos });

      if (items.length > 1) {
        if (this.hasVideo(event) || this.hasAllPhotos(event)) {
          this.navItems = items;
          this.navIsVisible = true;
        }
      }
    }

    setNavActiveItemId() {
      this.navActiveItemId = 'video';
    }

    hasVideo(event: any) {
      return event?.videos?.visibility === 'Visible';
    }

    hasAllPhotos(event: any) {
      return event?.allPhotosVisibility === 'Visible';
    }

    getDemoVideoUrl(): string {
      const event = { ...this.eventsState.event };
      return event?.videos?.preview?.fullVideoPreview || '';
    }

    getVideoAmount(): number {
      return this.videoProduct?.amount || 0;
    }

    async onBackToSearch(): Promise<void> {
      
      await this.cleanup();

      const event: any = this.eventsState.event;

      await this.$router.push({
        name: "video",
        params: {
          id: event.externalEventId,
        }
      });
    }

    async onShowMyPhotos(): Promise<void> {
      if (this.$route.name === "search-from-url") 
         return;
      
      await this.cleanup();

      const event: any = this.eventsState.event;

      const link: string = this.settingsState.myPhotosLink;
      if (link) {
        location.pathname = link;
        return;
      }

      await this.$router.push({
        name: "event",
        params: {
          id: event.externalEventId,
        }
      });
    }

    async onShowVideo(): Promise<void> {
      if (this.$route.name === "search-from-url-video") 
         return;

      await this.cleanup();

      const event: any = this.eventsState.event;

      await this.$router.push({
        name: "search-from-url-video",
        params: {
          id: event.externalEventId,
        }
      });
    }

    async onShowAllPhotos(): Promise<void> {
      if (this.$route.name === "event-photos") return;
      
      await this.cleanup();

      const event: any = this.eventsState.event;

      await this.$router.push({
        name: "event-photos",
        params: {
          id: event.externalEventId,
        }
      });
    }

    async onNavSelectItem(itemId: string): Promise<void> {
      if (!itemId) return;
      if (itemId === this.navActiveItemId) return;
      const item: any = this.navItems.find((i: any) => i.id === itemId);
      if (!item) return;
      if (typeof(item.action) === 'function') item.action();
    }

    async onShowOffers(): Promise<void> {
      this.packageOffersOptions = this.getPackageOffersOptions();
      this.disableVerticalScroll(true);
      this.showPackageOffers = true;
      this.settingsState.reachGoal('special_offers_details');
    }

    async onBeforeCart(): Promise<void> {
      await this.onGoToCart();
    }

    async onGoToCart(): Promise<void> {
      await this.cleanup();      

      this.$store.state.history = [];
      await this.$router.push({ name: "cart" });
    }

    async onAddAllVideos(): Promise<void> {
      if (this.isAddingVideos) return;

      this.isAddingVideos = true;

      if (!this.cartState.cart || this.cartState.cartId == "") {
        const cartId: string = uuidv4();
        await this.cartState.createCart({ cartId: cartId });
      }

      for (let i = 0; i < this.videos.length; i += 1) {
        const attributes = [{ key: 'VideoId', value: this.videos[i].videoId }];
        if (attributes.length === 0) {
          this.displayError(this.$t('searchResults/errorAddingProduct').toString());
          this.isAddingVideos = false;
          return;
        }
        const payload = { 
          cartId: this.cartState.cartId,
          searchToken: this.getCurrentSearchToken(),
          item: {
            catalogId: this.eventId,
            productId: this.videoProduct?.productId || '',
            attributes: attributes,
            additionalAttributes: this.getVideoAttributes(),
          }
        };
        
        await this.cartState.addItem(payload);
        if (this.cartState.isCartError) {
          this.displayError(this.$t('searchResults/errorAddingProduct').toString() + " " + this.cartState.responseStatus);
          this.isAddingVideos = false;
          return;
        }
      }
      
      await this.cartState.setCartAttributes({ cartId: this.cartState.cartId });
      await this.cartState.getCart({ cartId: this.cartState.cartId });
      await this.cartState.pushEcommerceAdd();
      this.isAddingVideos = false;
    
      await this.updateVideosInCart();

      this.showGiftForProduct(this.videoProduct);
      this.showPackageOffer(this.videoProduct?.productId);
    }

    async onAddVideo(index: number): Promise<void> {
      if (this.isAddingVideos) return;
      if (index < 0 || index > this.videos.length) return;

      this.isAddingVideos = true;

      if (!this.cartState.cart || this.cartState.cartId == "") {
        const cartId: string = uuidv4();
        await this.cartState.createCart({ cartId: cartId });
      }

      const attributes = [{ key: 'VideoId', value: this.videos[index].videoId }];
      if (attributes.length === 0) {
        this.displayError(this.$t('searchResults/errorAddingProduct').toString());
        this.isAddingVideos = false;
        return;
      }
      const payload = { 
        cartId: this.cartState.cartId,
        searchToken: this.getCurrentSearchToken(),
        item: {
          catalogId: this.eventId,
          productId: this.videoProduct?.productId || '',
          attributes: attributes,
          additionalAttributes: this.getVideoAttributes(),
        }
      };
      
      await this.cartState.addItem(payload);
      if (this.cartState.isCartError) {
        this.displayError(this.$t('searchResults/errorAddingProduct').toString() + " " + this.cartState.responseStatus);
        this.isAddingVideos = false;
        return;
      }
      
      await this.cartState.setCartAttributes({ cartId: this.cartState.cartId });
      await this.cartState.getCart({ cartId: this.cartState.cartId });
      await this.cartState.pushEcommerceAdd();
      this.isAddingVideos = false;
    
      await this.updateVideosInCart();

      this.showGiftForProduct(this.videoProduct);
      this.showPackageOffer(this.videoProduct?.productId);
    }

    async onAddPhotosWithMe(): Promise<void> {
      await this.$router.push({
        name: 'search-from-url',
        params: {
          id: this.eventsState.event.externalEventId,
          number: this.runnerNum,
          addPhotosWithMe: 'true',
        },
      }).catch(() => {});      
    }

    async onAddFrame(): Promise<void> {
      await this.$router.push({
        name: 'search-from-url',
        params: {
          id: this.eventsState.event.externalEventId,
          number: this.runnerNum,
        },
      }).catch(() => {});      
    }

    getCurrentSearchToken(): string {
      const newToken: string = this.searchToken ? this.searchToken.value || '' : '';
      return newToken || (this.$props.searchToken_ ? (this.$props.searchToken_.value || this.$props.searchToken_.token || '') : '');
    }

    async getNewSearchToken(payload: any): Promise<any> {
      const tokenResult = await this.searchState.getToken(payload);
      if (tokenResult.status !== 200) return null;
      return this.searchState.searchToken;
    }

    async onPhotosWithFrameAdd(): Promise<void> {
      await this.$router.push({
        name: 'search-from-url',
        params: {
          id: this.eventsState.event.externalEventId,
          number: this.runnerNum,
          photosWithFrameAdd: 'true',
        },
      }).catch(() => {});      
    }

    async addGift(gift: any): Promise<void> {
      if (!gift) return;
      await this.$router.push({
        name: 'search-from-url',
        params: {
          id: this.eventsState.event.externalEventId,
          number: this.runnerNum,
          gift: JSON.stringify(gift),
        },
      }).catch(() => {});
    }

    async onSearchByTag(): Promise<void> {
      this.runnersDialog = true;
      this.runnersDialogKey = Math.random().toString();
    }

    async onNewSearchByStartNumber(params: any): Promise<void> {
      await this.$router.push({
        name: 'search-from-url-video',
        params,
      });

      this.videos = [...this.searchState.videos];
      this.addVideoTitle();
      this.startFrom = this.photosPerPage;
      this.runnerNum = params.number;
      this.notFound__ = 'false';
    }

    async onRunnerChanged(hasResults: boolean): Promise<void> {
      if (hasResults) {
        setTimeout(async () => await this.updateRunnersHeight(), 100);
      } else {
        this.runnersHeight = "50px";
      }
    }

    async updateRunnersHeight(): Promise<void> {
      const r = document.getElementById(this.runnersContainerId);
      const f = document.getElementById('runnerSearchForm' + this.runnersDialogKey);
      if (r == null || f == null) return;

      const t = r.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;
      const height = windowHeight - t - 16;

      const formHeight = f.offsetHeight;

      this.runnersHeight = Math.min(height, formHeight) + "px";
    }

    async onRunnerSelected(value: { 
      competitorId: string, 
      surname?: string, 
      firstName?: string, 
      number: string,
      time?: string,
      position?: number,
      distance?: string,
    }): Promise<void> {
      this.runnersDialog = false;
      this.runnerNum = value.number;
      this.runnerLastName = value.surname || "";

      const runnerFrameValues: any = {
        competitorId: value.competitorId || "",
      };
      if (value.surname) runnerFrameValues["surname"] = value.surname;
      if (value.firstName) runnerFrameValues["firstName"] = value.firstName;
      if (value.time) runnerFrameValues["time"] = value.time;
      if (value.position) runnerFrameValues["position"] = value.position.toString();
      if (value.distance) runnerFrameValues["distance"] = value.distance;

      this.runnerFrameValues = runnerFrameValues;

      this.settingsState.reachGoal("media_member_selected");

      this.loading = true;
      await this.searchByTag();
      this.loading = false;
    }

    async searchByTag(): Promise<void> {
      location.pathname = `/search/${this.eventsState.event.externalEventId}/${this.runnerNum}/video`;
    }

    async onSearchSelfie(): Promise<void> {
      if (!this.input) return;
      
      this.input.setAttribute('capture', 'camera');
      await this.onSearchByFace();
    }

    async onSearchUpload(): Promise<void> {
      if (!this.input) return;
      
      this.input.removeAttribute('capture');
      await this.onSearchByFace();
    }

    async onSearchCancelled(): Promise<void> {
      this.captureDialog = false;
    }

    async onSearchByFace(): Promise<void> {
      if (!this.input) return;
      
      if (this.captureDialog) {
        this.captureDialog = false;
      } else {
        this.input.removeAttribute('capture');
      }
      
      this.searchResult = "searching";
      
      this.input.parentElement.reset();
      this.input.click();
    }

    async onPictureChange(): Promise<void> {
      if (!this.input) return;

      const curFiles = this.input.files;

      if (curFiles.length === 0) {
        this.selectedFile = null;
        this.redrawImage = false;
        this.$store.state.selectedFile = null;
      } else {
        this.loading = true;
        await this.loadImage(curFiles[0]);
        this.redrawImage = false;
        this.captureDialog = true;
        this.redrawImage = false;
        this.selectedFile = this.captureState.file;
        this.settingsState.reachGoal("media_selfie_uploaded");
        this.debouncedDoSearch();
        this.loading = false;
      }
    }

    async loadImage(selectedFile: File): Promise<void> {
      await this.captureState.loadImage(selectedFile);
      await this.captureState.loadFile(this.captureState.image.image.src);
      
      this.$store.state.selectedFile = this.captureState.file;
    }

    async searchByFace(): Promise<void> {
      this.redrawImage = true;

      await this.searchState.recognizePhoto({ file: this.selectedFile, albumId: this.eventId });
      if (this.searchState.searchError) {
        if (this.searchState.responseCode == 413) {
          this.searchResult = "too-big-file";
          return;
        } else if (this.searchState.responseCode == 500) {
          const result: boolean = await this.repeatSearchByFace();
          if (!result) return;
        } else {
          this.searchResult = "error";
          return;
        }
        this.captureDialog = false;
        return;
      }

      if (this.searchState.persons.length == 1) {

        const personId: string = this.searchState.persons[0].personId;
        if (!personId) {
          this.captureDialog = false;
          return;
        }

        location.pathname = `/search/${this.eventsState.event.externalEventId}/${this.searchState.selfieId + "+" + personId}/video`;

      } else if (this.searchState.persons.length == 0) {
        this.searchResult = "no-face";
      } else if (this.searchState.persons.length > 1) {
        this.searchResult = "many-people";
      } else {
        this.captureDialog = false;
      }
    }

    async repeatSearchByFace(): Promise<boolean> {
      await this.searchState.recognizePhoto({ file: this.selectedFile, albumId: this.eventId });
      
      if (this.searchState.searchError && this.searchState.responseCode == 413) {
        this.searchResult = "too-big-file";
        return false;
      } else if (this.searchState.searchError && this.searchState.responseCode == 500) {
        this.searchResult = "error";
        return false;
      } else if (this.searchState.searchError) {
        this.searchResult = "error";
        return false;
      }

      return true;
    }

    async onVideoClick(index: number): Promise<void> {
      this.previewVideos = this.videos.map((i: any) => {
        return {
          ...i,
          highResolutionUrl: this.getDemoVideoUrl(),
        }
      });
      this.currentVideoIndex = index;
      
      this.videoPreviewDialog = true;
    }

    @Watch("$props.backPageData_") 
    async onBackPageDataChanged(): Promise<void> {
      if (!this.$props.backPageData_) return;
      
      await this.cleanup();

      if (this.$props.backPageData_.name === "event") {
        await this.onBackToSearch();
        return;
      }

      await this.$router.push(this.$props.backPageData_);
    }

    @Watch("lang")
    async onLangChanged(): Promise<void> {
      await this.eventsState.getEventById(this.eventId);
      this.eventName = this.eventsState.event.title;

      this.setNavItems();

      const distance: string = this.selectedFrameValues["distance"] || "";
      await this.catalogState.getProducts({ eventId: this.eventId, distance });
      await this.loadProducts();

      if (this.$route.name !== 'event-photos') {
        this.frameProducts = this.getCatalogProducts(this.productTypes.frame);
      } else {
        this.frameProducts = [];
      }
      
      await this.fillPackageOffers();
    }

    @Watch("loading")
    async onShow(): Promise<void> {
      setTimeout(() => { this.settingsState.setLoadingRoute(this.loading) }, 1000);
    }

    @Watch("showPackageOffers")
    async onShowPackageOffersChanged(): Promise<void> {
      if (!this.showPackageOffers) {
        setTimeout(() => { this.disableVerticalScroll(false) }, 250);
      }
    }

    async cleanup(): Promise<void> {
      if (this.resultsMasonryGrid) {
        this.resultsMasonryGrid.destroy();
      }
      this.resultsMasonryGrid = null;
    }

    async onItemMouseLeave(event: MouseEvent): Promise<void> {
      if (this.smOnly) return;

      if (this.hoveredItemIndex == -1 || this.videos.length-1 < this.hoveredItemIndex)
        return;

      const itemId = "results-item-" + this.videos[this.hoveredItemIndex].videoId;
      const item = document.getElementById(itemId);
      if (item == null) return;

      const rect = item.getBoundingClientRect();

      if ((event.clientY >= rect.top && 
          event.clientY <= (rect.top + rect.height) &&
          event.clientX <= (rect.left + rect.width) && 
          event.clientX >= rect.left)) {
        return;
      } else {
        this.hoveredItemIndex = -1;
      }
    }

    async onItemDropDown(value: boolean): Promise<void> {
      this.itemDropdown = value;
    }

    async initMasonry(): Promise<void> {
      const resultsGrid: any = this.$refs.searchResultsGrid;
      if (resultsGrid) {
        this.resultsMasonryGrid = new Masonry(resultsGrid, {
          itemSelector: ".search-results-grid__item",
          columnWidth: ".search-results-grid__sizer",
          percentPosition: true,
          initLayout: false,
        });

        const vm = this;

        vm.resultsMasonryGrid.once('layoutComplete', async () => { });
        vm.resultsMasonryGrid.layout();

        let resizeTimeout: any = null;

        window.addEventListener('resize', () => {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(vm.reloadResultsGrid, 400);
        });
      }
    }
    
    async reloadResultsGrid(): Promise<void> {
      if (this.$route.name != 'search' && this.$route.name != 'search-from-url-video')
        return;

      if (this.resultsMasonryGrid) {
        this.resultsMasonryGrid.layout();
      }
    }

    async fillVideos(): Promise<void> {
      const videos = JSON.parse(this.$props.videos_)
      this.videos = videos;
      this.startFrom = this.photosPerPage;
    }

    addVideoTitle() {
      this.videos = this.videos.map((v: any) => {
        return {
          ...v,
          title: this.videoProduct?.title,
        }
      });
    }

    async updateElements(available: any[]): Promise<void> {
      const grid = document.getElementsByClassName('search-results-grid')[0];
      const items: any = grid.getElementsByClassName('search-results-grid__item');
      let firstIndex: number = items.length - available.length;
      if (firstIndex < 0) firstIndex = 0;
      
      const newElems: any[] = [];
      for (let i = firstIndex; i < items.length; i++) {
        newElems.push(items[i]);
      }

      if (newElems.length > 0) {
        await this.updateMasonry(newElems);
      } else {
        await this.setUpdating(false);
      }
    }

    async updateVideosInCart(): Promise<void> {
      const videosIds: string[] = [];

      if (this.cartState.cartId !== '' && this.cartState.cartItems.length > 0) {
        const cartItems = this.cartState.cartItems;

        for (let i = 0; i < cartItems.length; i++) {
          const items: string[] = this.getItemVideos(cartItems[i]);
          if (items.length === 0) continue;

          videosIds.push(...items);
        }
      }

      this.videosInCart = videosIds;
    }

    async updateMasonry(items: any): Promise<void> {
      const vm = this;
      setTimeout(async () => {    
          if (!vm.resultsMasonryGrid)
            return;

          vm.resultsMasonryGrid.once('layoutComplete', 
            async () => {
              if (items.length > 0) 
                vm.startFrom += this.photosPerPage;

              await vm.setUpdating(false);
            } 
          );

          vm.resultsMasonryGrid.appended(items);
        },
        500,
      );
    }

    async setUpdating(updating: boolean): Promise<void> {
      const vm = this;
      setTimeout(() => {
          vm.updating = updating;
        }, 
        500,
      );
    }

    async loadProducts(): Promise<void> {
      const items: any[] = [ ...this.catalogState.products ];
      
      for (let i = 0; i < items.length; i += 1) {
        const found: any[] = this.catalogProducts.filter((r: any) => r.productId === items[i].productId);
        if (found.length > 0) continue;
        
        await this.catalogState.getProduct({ productId: items[i].productId });

        if (this.catalogState.product) {
          const product: any = { ...this.catalogState.product };
          product["productId"] = items[i].productId;
          product["type"] = items[i].productType;
          
          this.catalogProducts.push(product);
        }
      }
    }

    async fillPackageOffers(): Promise<void> {
      const result: any[] = [];

      if (this.photosWithMeProduct
        && this.photosWithMeDiscount > 0
        && this.$route.name !== 'event-photos'
      ) {
        result.push({
          title: this.$t('productPreview/productAllPhotos'),
          productId: this.photosWithMeProduct.productId,
          productType: this.photosWithMeProduct.productType,
          price: this.photosWithMeProduct.amount,
          size: 0,
          oldPrice: this.photoProduct ? this.photoProduct.amount * this.searchState.photosTotal : 0,
        });
      }

      if (this.photosWithMeProduct) {
        let offers = Object.assign([], this.photosWithMeProduct.packageOffers);
        if (offers.length > 0) {
          offers = offers.sort(this.sortOffers);
          offers = offers.map((i: any) => {
            return {
              ...i,
              title: this.photosWithMeProduct.title,
              productId: this.photosWithMeProduct.productId,
              productType: this.photosWithMeProduct.productType,
              oldPrice: this.photosWithMeProduct.amount * i.size,
            }
          });
          if (offers.length > 0 && offers[0].size !== 1) {
            const one = { ...offers[0] };
            one.size = 1;
            one.price = this.photosWithMeProduct.amount;
            one.oldPrice = this.photosWithMeProduct.amount;
            offers = [one, ...offers];
          }
          result.push(...offers);
        }
      }

      if (this.photosWithFrameProduct) {
        let offers = Object.assign([], this.photosWithFrameProduct.packageOffers);
        if (offers.length > 0) {
          offers = offers.sort(this.sortOffers);
          offers = offers.map((i: any) => {
            return {
              ...i,
              title: this.photosWithFrameProduct.title,
              productId: this.photosWithFrameProduct.productId,
              productType: this.photosWithFrameProduct.productType,
              frameId: Common.getAttribute(this.photosWithFrameProduct.attributes, 'FrameId'),
              oldPrice: this.photosWithFrameProduct.amount * i.size,
            }
          });
          if (offers.length > 0 && offers[0].size !== 1) {
            const one = { ...offers[0] };
            one.size = 1;
            one.price = this.photosWithFrameProduct.amount;
            one.oldPrice = this.photosWithFrameProduct.amount;
            offers = [one, ...offers];
          }
          result.push(...offers);
        }
      }

      if (this.photoProduct) {
        let offers = Object.assign([], this.photoProduct.packageOffers);
        if (offers.length > 0) {
          offers = offers.sort(this.sortOffers);
          offers = offers.map((i: any) => {
            return {
              ...i,
              title: this.$t('productPreview/productDigitalPhoto').toString(),
              productId: this.photoProduct.productId,
              productType: this.photoProduct.productType,
              oldPrice: this.photoProduct.amount * i.size,
            }
          });
          if (offers.length > 0 && offers[0].size !== 1) {
            const one = { ...offers[0] };
            one.size = 1;
            one.price = this.photoProduct.amount;
            one.oldPrice = this.photoProduct.amount;
            offers = [one, ...offers];
          }
          result.push(...offers);
        }
      }

      if (this.videoProduct) {
        let offers = Object.assign([], this.videoProduct.packageOffers);
        if (offers.length > 0) {
          offers = offers.sort(this.sortOffers);
          offers = offers.map((i: any) => {
            return {
              ...i,
              title: this.videoProduct.title,
              productId: this.videoProduct.productId,
              productType: this.videoProduct.productType,
              oldPrice: this.videoProduct.amount * i.size,
            }
          });
          if (offers.length > 0 && offers[0].size !== 1) {
            const one = { ...offers[0] };
            one.size = 1;
            one.price = this.videoProduct.amount;
            one.oldPrice = this.videoProduct.amount;
            offers = [one, ...offers];
          }
          result.push(...offers);
        }
      }

      if (this.frameProducts.length > 0) {
        for (let i = 0; i < this.frameProducts.length; i++) {
          let offers = Object.assign([], this.frameProducts[i].packageOffers);
          if (offers.length > 0) {
            offers = offers.sort(this.sortOffers);
            offers = offers.map((r: any) => {
              return {
                ...r,
                title: this.frameProducts[i].title,
                productId: this.frameProducts[i].productId,
                productType: this.frameProducts[i].productType,
                frameId: Common.getAttribute(this.frameProducts[i].attributes, 'FrameId'),
                oldPrice: this.frameProducts[i].amount * r.size,
              }
            });
            if (offers.length > 0 && offers[0].size !== 1) {
              const one = { ...offers[0] };
              one.size = 1;
              one.price = this.frameProducts[i].amount;
              one.oldPrice = this.frameProducts[i].amount;
              offers = [one, ...offers];
            }
            result.push(...offers);
          }
        }
      }

      if (this.promocodeProduct) {
        let offers = Object.assign([], this.promocodeProduct.packageOffers);
        if (offers.length > 0) {
          offers = offers.sort(this.sortOffers);
          offers = offers.map((i: any) => {
            return {
              ...i,
              title: this.promocodeProduct.title,
              productId: this.promocodeProduct.productId,
              productType: this.promocodeProduct.productType,
              oldPrice: this.promocodeProduct.amount * i.size,
            }
          });
          if (offers.length > 0 && offers[0].size !== 1) {
            const one = { ...offers[0] };
            one.size = 1;
            one.price = this.promocodeProduct.amount;
            one.oldPrice = this.promocodeProduct.amount;
            offers = [one, ...offers];
          }
          result.push(...offers);
        }
      }

      const filtered: any[] = [];
      for (let i = 0; i < result.length; i++) {
        if (result[i].size <= this.searchState.photosTotal) {
          filtered.push(result[i]);
        }
      }

      this.packageOffers = filtered;

    }

    openSearchStartNumber() {
      const searchStartNumber = this.$refs.searchStartNumber as any;
      searchStartNumber.open();
    }

    openSearchSelfie() {
      const searchSelfie = this.$refs.searchSelfie as any;
      searchSelfie.open();
    }

    openSearchEmail() {
      const searchEmail = this.$refs.searchEmail as any;
      searchEmail.open();
    }

    async created(): Promise<void> {
      this.runnersContainerId = "runners" + Math.random().toString();

      this.debouncedDoSearch = Debounce(this.searchByFace, 500);

      await this.updateRunnersHeight();

      window.addEventListener("resize", async () => {
          await this.updateRunnersHeight();
        }
      );
    }

    async mounted(): Promise<void> {
      this.eventId = this.$props.eventId_;
      this.eventName = this.$props.eventName_;
      this.eventDate = this.$props.eventDate_;
      this.is2FAEnabled = this.$props.is2FAEnabled_;
      this.isAllPhotosVisible = this.$props.isAllPhotosVisible_;
      this.runnerNum = this.$props.runnerNum_;
      this.runnerFrameValues = this.$props.runnerFrameValues_ ? JSON.parse(this.$props.runnerFrameValues_) : null;

      this.byFace = (this.$props.byFace_ == "true");
      this.faceImage = this.$props.faceImage_;
      this.selfieId = this.$props.selfieId_;
      this.personId = this.$props.personId_;

      await this.updateVideosInCart();
      
      this.notFound__ = this.$props.notFound_;

      this.tagged = await this.isTagged();

      this.updating = true;
      this.setNavItems();
      this.setNavActiveItemId();
      await this.fillVideos();
      this.updating = false;

      this.setSelectedFrameValues();
      const distance: string = this.selectedFrameValues["distance"] || "";
      await this.catalogState.getProducts({ eventId: this.eventId, distance });
      await this.loadProducts();

      if (!this.videoProduct && this.videos.length > 0) {
        this.notFound__ = "true";
      }
      this.addVideoTitle();

      if (this.photoProduct) {
        this.itemPhotoPrice = this.photoProduct.amount;
      }
      this.frameProducts = this.getCatalogProducts(this.productTypes.frame);

      await this.fillPackageOffers();

      await this.updateSbpState();

      this.loading = false;

      this.setPictureHandlers();

      await this.updateRunnersHeight();

      const vm = this;
      this.$nextTick(async () => { 
        if (vm.resultsMasonryGrid === null && vm.videos.length > 0) {
          setTimeout(async () => {
            await vm.initMasonry();
          }, 500);
        }
      });

    }

  }
